var map = {
	"./br/PT/S1/gm3.png": 32246,
	"./in/EN/S1/gm3.png": 75324,
	"./ph/EN/S1/gm3.png": 30741,
	"./vn/VI/S1/gm3.png": 37442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97206;